import React from 'react';

export default function Image({ src, alt, ...props }) {
  const handleError = (event) => {
    event.currentTarget.src = '/img/noimage.png';
  };

  return <img src={src} alt={alt} onError={handleError} {...props} />;
}
